import { Button, Form, Row, Col } from "react-bootstrap"

const AmazonExportViews = ({ exportFile }) => { 
  return(
    <Button variant="outline-primary" onClick={exportFile}>Export to Xlsx</Button>
  )
}

export default AmazonExportViews;